import request from '@/request/request'


// 查询设备数据统计列表
export function listEquipmentDataStat(query) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/list',
        method: 'get',
        params: query
    })
}

// 查询设备数据统计详细
export function getEquipmentDataStatById(id) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/' + id,
        method: 'get'
    })
}

// 新增设备数据统计
export function addEquipmentDataStat(data) {
    return request({
        url: '/api/equipment-server/equipmentDataStat',
        method: 'post',
        data: data
    })
}

// 修改设备数据统计
export function updateEquipmentDataStat(data) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/edit',
        method: 'post',
        data: data
    })
}

// 删除设备数据统计
export function delEquipmentDataStat(id) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/delete/' + id,
        method: 'post'
    })
}

//按天聚合查询客流统计
export function listAggregationDay(data) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/aggregationDay',
        method: 'post',
        data: data
    })
}
//天气接口
export function getWeathermoji(data) {
    return request({
        url: '/api/equipment-server/weather/moji',
        method: 'post',
        data: data
    })
}

// 天气接口（analysis /weather/getWeather，和 h5_zjht_dataview 用同一个，返回 forecast/wendu 格式）
export function getWeatherByCity(data) {
    return request({
        url: '/api/analysis/weather/getWeather',
        method: 'post',
        data: data
    })
}
//聚合查询wifi统计
export function getWifiUsrCount(params) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/getWifiUsrCount',
        method: 'get',
        params
    })
}
